module.exports = __webpack_public_path__ + "static/media/Guatemala_5Dol_Todo.9cd3f1db.jpg";